/* ==========================================================
   LUI · Landing Minoxidil Oral
   Planes: 1 mes · Pack 2 meses · Pack 3 meses (3x2, preseleccionado)
   ========================================================== */
(function () {
  'use strict';

  function boot(root) {
    if (!root || root.dataset.luiReady === '1') return;
    root.dataset.luiReady = '1';

    var data = {};
    try {
      data = JSON.parse(root.querySelector('[data-lui-data]').textContent);
    } catch (e) {
      return;
    }

    /* ---------------- Contador perenne ---------------- */
    (function countdown() {
      var box = root.querySelector('[data-lui-clock]');
      if (!box) return;
      var span = parseFloat(root.dataset.luiHours || '24') * 3600 * 1000;
      var key = 'lui_promo_deadline_v1';
      var end = parseInt(localStorage.getItem(key) || '0', 10);
      if (!end || isNaN(end) || end <= Date.now()) {
        end = Date.now() + span;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }
      var cells = box.querySelectorAll('[data-unit]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          end = Date.now() + span;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
          left = span;
        }
        var s = Math.floor(left / 1000);
        var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        cells.forEach(function (c) { c.textContent = pad(v[c.dataset.unit]); });
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ---------------- Galería ---------------- */
    (function gallery() {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lui-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lui-thumb]'));
      if (!slides.length) return;
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        var act = thumbs[i];
        if (act && act.parentElement) act.parentElement.scrollTo({ left: act.offsetLeft - 60, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var p = root.querySelector('[data-lui-prev]');
      var n = root.querySelector('[data-lui-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (n) n.addEventListener('click', function () { go(i + 1); });
      var main = root.querySelector('[data-lui-gal]');
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 44) go(dx < 0 ? i + 1 : i - 1);
          x0 = null;
        }, { passive: true });
      }
      go(0);
    })();

    /* ---------------- FAQ ---------------- */
    root.querySelectorAll('[data-lui-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.lui-faq__item');
        var open = item.classList.contains('is-open');
        root.querySelectorAll('.lui-faq__item').forEach(function (it) { it.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    /* ---------------- Selector de plan ---------------- */
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-lui-tier]'));
    var pick = '3';
    var preset = tiers.filter(function (t) { return t.classList.contains('is-on'); })[0];
    if (preset) pick = preset.dataset.luiTier;

    function setText(sel, value) {
      if (value == null) return;
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }

    function offer() { return (data.tiers || {})[pick] || {}; }

    function render() {
      var o = offer();
      setText('[data-lui-price-now]', '$' + o.price);
      setText('[data-lui-price-was]', o.was ? '$' + o.was : '');
      setText('[data-lui-price-unit]', o.unit);
      setText('[data-lui-cta-label]', o.cta);
      setText('[data-lui-cta-short]', o.short);
      setText('[data-lui-cta-sub]', o.sub);
      setText('[data-lui-headnote]', o.note);
      setText('[data-lui-sticky-sub]', o.stickySub);

      root.querySelectorAll('[data-lui-price-was]').forEach(function (el) {
        el.style.display = o.was ? '' : 'none';
      });
      root.querySelectorAll('[data-lui-price-tag]').forEach(function (el) {
        if (o.save) {
          el.textContent = 'Ahorras $' + o.save + (o.pct ? ' · ' + o.pct : '');
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      tiers.forEach(function (t) {
        var on = t.dataset.luiTier === pick;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', String(on));
      });

      var hint = root.querySelector('[data-lui-hint]');
      if (hint) {
        hint.textContent = o.hint || '';
        hint.style.color = '#3f7d52';
      }
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        pick = t.dataset.luiTier;
        render();
      });
    });

    /* ---------------- Agregar al carrito ---------------- */
    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-lui-cta]'));

    function addToCart(e) {
      e.preventDefault();
      var btn = e.currentTarget;
      var restore = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Agregando...';

      var items = [{ id: Number(data.variant_id), quantity: parseInt(pick, 10) }];

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || 'No se pudo agregar');
          var code = offer().code;
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
            : '/checkout';
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.innerHTML = restore;
          alert('No pudimos agregar tu pedido: ' + err.message);
        });
    }

    ctas.forEach(function (c) { c.addEventListener('click', addToCart); });

    /* ---------------- Sticky móvil ---------------- */
    (function sticky() {
      var bar = root.querySelector('[data-lui-sticky]');
      var anchor = root.querySelector('[data-lui-picker]');
      var last = root.querySelector('.lui-final');
      if (!bar || !anchor) return;
      var lastRun = 0;
      function update() {
        lastRun = Date.now();
        var passed = anchor.getBoundingClientRect().bottom < 0;
        var atEnd = last ? last.getBoundingClientRect().top < window.innerHeight : false;
        bar.classList.toggle('is-on', passed && !atEnd);
      }
      function onScroll() {
        if (Date.now() - lastRun < 80) return;
        update();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    })();

    render();
  }

  function init() { document.querySelectorAll('[data-lui-root]').forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
